import { createBrowserRouter } from 'react-router';

import { ROUTE_PATH } from '@shared/router';
import AppRouteLayout from '@shared/router/app-route-layout';
import {
  LoginPage,
  OnboardingPage,
  TermsAgreementPage,
} from '@shared/router/lazy';
import {
  appRouteLoader,
  guestOnlyLoader,
  onboardingGuardLoader,
  termsGuardLoader,
} from '@shared/router/loader';
import OnboardingRouteLayout from '@shared/router/onboarding-route-layout';
import {
  protectedAppRoutes,
  publicRoutes,
} from '@shared/router/routes/global-routes';

export const router = createBrowserRouter([
  ...publicRoutes,
  {
    Component: OnboardingRouteLayout,
    children: [
      {
        path: ROUTE_PATH.LOGIN,
        loader: guestOnlyLoader,
        Component: LoginPage,
      },
      {
        path: ROUTE_PATH.TERMSAGREEMENT,
        loader: termsGuardLoader,
        Component: TermsAgreementPage,
      },
      {
        path: ROUTE_PATH.ONBOARDING,
        loader: onboardingGuardLoader,
        Component: OnboardingPage,
      },
    ],
  },
  {
    Component: AppRouteLayout,
    loader: appRouteLoader,
    children: protectedAppRoutes,
  },
]);
